module.exports = __webpack_public_path__ + "img/product_icon.4ef8040b.png";